import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      ADDONS: "Dagligvarer",
      YOU_SUBSCRIBE_TO_THE_FOLLOWING_ADDONS:
        "Du abonnerer på følgende dagligvarer:",
      YOU_MAY_ADD_ADDONS_FOR_EXAMPLE:
        "Du kan legge til matvarer i abonnementet ditt som f.eks. olje og smør. Varene kommer med din levering i hver bestilling.",
      ADDONS_BUTTON: (addonCount: number) =>
        addonCount === 0 ? "Legg til dagligvarer" : "Endre dagligvarer",
    },

    dk: {
      ADDONS: "Specialvarer",
      YOU_SUBSCRIBE_TO_THE_FOLLOWING_ADDONS:
        "Du abonnerer på følgende specialvarer:",
      YOU_MAY_ADD_ADDONS_FOR_EXAMPLE:
        "Vi tilbyder bl.a. frugtkaser, brød og vin, som du kan bestille hjem sammen med din måltidskasse.",
      ADDONS_BUTTON: (addonCount: number) =>
        addonCount === 0 ? "Tilføj specialvarer" : "Ændr specialvarer",
    },

    se: {
      ADDONS: "Livsmedel",
      YOU_SUBSCRIBE_TO_THE_FOLLOWING_ADDONS:
        "Du prenumererar på följande livsmedel:",
      YOU_MAY_ADD_ADDONS_FOR_EXAMPLE:
        "Du kan lägga till livsmedel i din prenumeration som t. ex. olja och smör. Varorna kommer tillsammans med din leverans i varje beställning.",
      ADDONS_BUTTON: (addonCount: number) =>
        addonCount === 0 ? "Lägg till livsmedel" : "Ändra livsmedel",
    },
  } as const
)[language];
